var _rect, _rect2, _rect3, _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddContactBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddContact_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1179",
    "data-name": "Rectangle 1179",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    opacity: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M17.13,13.35a4.5,4.5,0,1,0,4.5,4.5A4.494,4.494,0,0,0,17.13,13.35Zm1.73,4.85H17.48v1.38a.35.35,0,1,1-.7,0V18.2H15.4a.35.35,0,0,1,0-.7h1.38V16.12a.35.35,0,1,1,.7,0V17.5h1.38a.35.35,0,1,1,0,.7Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    d: "M15.71,21.36A19.838,19.838,0,0,1,4.53,20.25c.07-3.64,3.39-6.57,7.47-6.57a10.6,10.6,0,0,1,3.16.58",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M15.74,6.02A3.74,3.74,0,1,1,12,2.28h0a3.761,3.761,0,0,1,1.61.36",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(14.49 3.59)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContactBtnIcon);
export default __webpack_public_path__ + "static/media/add-contact-btn-icon.2e0e8c19300dc57d537e63b0020b76c4.svg";
export { ForwardRef as ReactComponent };